import type { CityConfig } from "../city-template/types";

export const charlotteConfig: CityConfig = {
  city: "Charlotte",
  state: "North Carolina",
  stateAbbr: "NC",
  slug: "charlotte",
  route: "/cities/charlotte",
  title: "Emergency Passport Charlotte, NC | Expedited Passport Services | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Charlotte, NC — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving Mecklenburg County and the Greater Charlotte metro area. Get your passport fast!",
  h1: "Emergency & Expedited Passport Services in Charlotte, NC",
  heroSubtitle: "Passport expired before your trip? Need an emergency passport fast? We help Charlotte and Greater Charlotte metro area travelers get their expedited passports as quickly as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Stunning%20panoramic%20photograph%20of%20Charlotte%20North%20Carolina%20skyline%20at%20golden%20hour%20with%20modern%20glass%20skyscrapers%20reflecting%20warm%20amber%20sunlight%2C%20the%20Bank%20of%20America%20Corporate%20Center%20tower%20visible%2C%20lush%20green%20tree%20canopy%20in%20the%20foreground%2C%20clean%20blue%20sky%20with%20soft%20clouds%2C%20professional%20cityscape%20photography%20with%20vibrant%20warm%20colors%20and%20sharp%20architectural%20details%2C%20no%20text%20or%20signs%20on%20buildings&width=1800&height=700&seq=charlotte-hero-nc-001&orientation=landscape",
  heroImageAlt: "Charlotte North Carolina downtown skyline at golden hour with modern skyscrapers",
  geoPosition: "35.2271;-80.8431",
  geoPlacename: "Charlotte, North Carolina",
  regionalAgency: {
    name: "Atlanta Passport Agency",
    address: "230 Peachtree Street NW, Suite 1400, Atlanta, GA 30303",
    distance: "Located in downtown Atlanta — approximately 250 miles from Charlotte via I-85",
  },
  nearbyCitiesZips: [
    { name: "Charlotte", zips: "28201–28299" },
    { name: "Matthews", zips: "28104, 28105" },
    { name: "Mint Hill", zips: "28227, 28262" },
    { name: "Huntersville", zips: "28070, 28078" },
    { name: "Concord", zips: "28025, 28026, 28027" },
    { name: "Gastonia", zips: "28052, 28053, 28054, 28056" },
    { name: "Mooresville", zips: "28115, 28117" },
    { name: "Cornelius", zips: "28031" },
    { name: "Davidson", zips: "28035, 28036" },
    { name: "Pineville", zips: "28134" },
    { name: "Fort Mill, SC", zips: "29707, 29708, 29715, 29716" },
    { name: "Rock Hill, SC", zips: "29730, 29731, 29732, 29733" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent Charlotte departures" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-map-pin-2-line", title: "Mecklenburg County Hub", desc: "Serving Charlotte, Matthews, Huntersville, and the entire metro area" },
  ],
  internalLinks: [
    { name: "Expedited passport services in Raleigh, NC", route: "/cities/raleigh" },
    { name: "Fast passport renewal in Greensboro, NC", route: "/cities/greensboro" },
    { name: "Emergency passport help in Winston-Salem, NC", route: "/cities/winston-salem" },
    { name: "Urgent passport services in Durham, NC", route: "/cities/durham" },
    { name: "Same-day passport help in Huntersville, NC", route: "/cities/huntersville" },
    { name: "Passport courier services in Cornelius, NC", route: "/cities/cornelius" },
    { name: "Passport courier services in Davidson, NC", route: "/cities/davidson" },
    { name: "Passport courier services in Kannapolis, NC", route: "/cities/kannapolis" },
    { name: "Passport courier services in Matthews, NC", route: "/cities/matthews" },
    { name: "Passport courier services in Mooresville, NC", route: "/cities/mooresville" },
    { name: "Passport courier services in Gastonia, NC", route: "/cities/gastonia" },
    { name: "Passport courier services in Hickory, NC", route: "/cities/hickory" },
    { name: "Expedited passport services in Statesville, NC", route: "/cities/statesville" },
    { name: "Fast passport renewal in Salisbury, NC", route: "/cities/salisbury" },
    { name: "Passport courier services in Indian Trail, NC", route: "/cities/indian-trail" },
    { name: "Expedited passport services in Harrisburg, NC", route: "/cities/harrisburg" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Charlotte remotely via secure courier. We do not have a walk-in office in Charlotte — our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for Mecklenburg County and the Greater Charlotte metro area travelers.",
  fpcOfficeDistance: "Serving all of Mecklenburg County and the Greater Charlotte metro area including South Carolina border communities",
  serviceAreaIntro: "From Uptown Charlotte to the suburbs of Matthews, Mint Hill, and Huntersville, from Ballantyne to Lake Norman and Davidson — Fast Passport Center serves the entire Greater Charlotte region. We regularly help travelers from Concord, Gastonia, Mooresville, and Fort Mill, SC get their passports fast.",
  nearbyCitiesIntro: "We serve all Charlotte neighborhoods and the surrounding metro area including Matthews, Mint Hill, Huntersville, Concord, Gastonia, Mooresville, Cornelius, Davidson, Pineville, and across the state line into Fort Mill and Rock Hill, South Carolina. If you are anywhere in the Charlotte–Concord–Gastonia metropolitan area, we have you covered.",
  howItWorksIntro: "Most Charlotte travelers complete everything online and ship documents overnight. No need to drive to Atlanta or wait in line at the regional agency.",
  mistakesIntro: "Charlotte travelers often face long drives to the nearest regional passport agency. Here are the most common mistakes that cause delays.",
  testimonialsIntro: "Charlotte and Mecklenburg County travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Charlotte? Here are the most common ones we hear from Mecklenburg County travelers.",
  statePageRoute: "/states/north-carolina",
  statePageName: "North Carolina",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins allowed",
        "Life-or-death emergencies only",
        "Bereavement or medical crisis",
        "Expect to wait all day or return next day",
      ],
      highlight: false,
      emergency: true,
    },
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Predictable turnaround",
        "Ideal for upcoming trips",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service",
        "Good for planned travel",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–3",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "Workload & wait times shift with shutdowns",
        "In-person clerk appointment required",
        "No document review — errors cause rejection",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "No phone or email contact for your case",
        "Can't upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For travelers with immediate departure needs — as fast as 24 hours for urgent Charlotte international flights.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance and police report documentation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
    { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
    { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
    { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  ],
  testimonials: [
    {
      name: "Jennifer M.",
      location: "Charlotte, NC",
      rating: 5,
      text: "My passport expired the week before a business trip to London. Fast Passport Center had my renewal ready in 4 days. I never had to leave Charlotte. Absolutely incredible service.",
      service: "Passport Renewal",
    },
    {
      name: "David K.",
      location: "Matthews, NC",
      rating: 5,
      text: "Emergency passport for a family emergency in Germany. Got it in 36 hours. The team kept me updated every step. I was amazed this could happen without driving to Atlanta.",
      service: "Emergency Passport",
    },
    {
      name: "Sarah L.",
      location: "Huntersville, NC",
      rating: 5,
      text: "First passport for my 10-year-old before our cruise. Fast Passport Center walked us through every document and had her passport ready in 5 days. Stress-free from start to finish.",
      service: "Child Passport",
    },
    {
      name: "Robert T.",
      location: "Concord, NC",
      rating: 5,
      text: "Lost my passport 4 days before a conference in Tokyo. Fast Passport Center had a replacement in my hands in 30 hours. These guys are lifesavers.",
      service: "Lost Passport",
    },
  ],
  facilities: [
    {
      id: "charlotte-1",
      name: "Charlotte Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "201 N Tryon St",
      city: "Charlotte",
      state: "NC",
      zip: "28202",
      phone: "(704) 344-4183",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Downtown Charlotte, Uptown area",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Charlotte facility. High volume — appointments strongly recommended. Call ahead to confirm passport acceptance.",
      icon: "ri-mail-line",
    },
    {
      id: "charlotte-2",
      name: "Matthews Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "11435 E Independence Blvd",
      city: "Matthews",
      state: "NC",
      zip: "28105",
      phone: "(704) 847-2511",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Southeast Charlotte suburb",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Matthews and Mint Hill residents. Less crowded than downtown. Photo services nearby.",
      icon: "ri-mail-line",
    },
    {
      id: "charlotte-3",
      name: "Huntersville Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "16835 Caldwell Creek Dr",
      city: "Huntersville",
      state: "NC",
      zip: "28078",
      phone: "(704) 875-3513",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "North Charlotte, Lake Norman area",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Huntersville, Cornelius, and Davidson area. Ample parking. Appointments required.",
      icon: "ri-mail-line",
    },
    {
      id: "charlotte-4",
      name: "Concord Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "7850 International Dr",
      city: "Concord",
      state: "NC",
      zip: "28027",
      phone: "(704) 788-2511",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Northeast Charlotte suburb",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Cabarrus County and northeast Charlotte metro. Call for appointment availability.",
      icon: "ri-mail-line",
    },
    {
      id: "charlotte-5",
      name: "Mecklenburg County Clerk of Court",
      type: "Court Clerk Passport Acceptance",
      address: "832 E 4th St",
      city: "Charlotte",
      state: "NC",
      zip: "28202",
      phone: "(704) 686-0200",
      hours: "Mon–Fri: 8:00 AM – 5:00 PM",
      distance: "Mecklenburg County Courthouse, Uptown",
      website: "https://www.mecknc.gov/",
      websiteLabel: "Mecklenburg County Clerk",
      notes: "Accepts passport applications. Good alternative to post office with extended hours. Appointment recommended.",
      icon: "ri-government-line",
    },
    {
      id: "charlotte-6",
      name: "Gastonia Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "115 W Main Ave",
      city: "Gastonia",
      state: "NC",
      zip: "28052",
      phone: "(704) 866-4501",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "West Charlotte, Gaston County",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Gaston County and west Charlotte metro. Full passport services available.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 4 hour drive to Atlanta", fpc: "No — ship from home or office" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Charlotte photo shops often use generic sizes. Passport photos must be exactly 2×2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 reasons for rejection at Mecklenburg County acceptance facilities.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Fees change frequently. Many Charlotte applicants show up with incorrect payment and have to reschedule their appointment.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, the regional agency will turn you away for emergency appointments.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For minors, both parents must appear or submit notarized consent. This trips up many Mecklenburg County families at the clerk.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "Charlotte travelers often assume standard processing will be fine. It takes 8–11 weeks. Start expedited at least 3 weeks before travel.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS location in Charlotte." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Charlotte address — trackable every step of the way." },
  ],
  faqs: [
    { q: "Can I get an emergency passport in Charlotte before international travel?", a: "Yes. Fast Passport Center provides emergency passport services in Charlotte for travelers with urgent international flights. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities, achieving 24–48 hour turnaround — without the 4 hour drive to Atlanta." },
    { q: "How fast can I renew my passport in Charlotte?", a: "Fast Passport Center offers fast passport renewal in Charlotte in as little as 24–48 hours through our emergency courier service. For less urgent travel, our 3–5 day expedited option provides the best value. Both options include full document review and a dedicated agent." },
    { q: "What is the closest passport agency to Charlotte?", a: "The nearest regional passport agency to Charlotte is the Atlanta Passport Agency, approximately 250 miles away via I-85. For urgent processing without the long drive, Fast Passport Center's registered courier service achieves 24–48 hour turnaround from Charlotte without any in-person agency visit required." },
    { q: "Can I get a same-day passport appointment near Charlotte?", a: "Same-day passport appointments are only available at the Atlanta Regional Passport Agency — approximately 4 hours from Charlotte — for documented life-or-death emergencies. For all other urgent travel, Fast Passport Center's 24–48 hour emergency courier processing is the fastest guaranteed option for Mecklenburg County residents." },
    { q: "Do you serve the South Carolina border communities?", a: "Absolutely. Fast Passport Center serves the entire Charlotte metro area including Fort Mill, Rock Hill, and Tega Cay in South Carolina. Our courier service works seamlessly from any address in the Charlotte–Concord–Gastonia metropolitan area." },
    { q: "Can I expedite a child passport in Charlotte?", a: "Yes. Fast Passport Center expedites child passports in Charlotte for minors under 16. Both parents must appear or submit notarized consent, along with the child's birth certificate and both parents' IDs. We walk Mecklenburg County families through the entire process." },
    { q: "What should I do if I lost my passport before a trip?", a: "If you lost your passport before a trip, contact Fast Passport Center immediately. We provide lost passport replacement services in Charlotte with DS-64 form guidance and identity verification support. Our emergency courier service can get your replacement passport in 24–48 hours." },
    { q: "Do I need to drive to the Atlanta Passport Agency?", a: "No. With Fast Passport Center, you complete everything online and ship your documents overnight. Our couriers handle the in-person delivery to State Department facilities. You only need to visit a local acceptance clerk if you're a first-time applicant or need a name change." },
  ],
  photoLocations: [
    { name: "CVS Pharmacy — Uptown Charlotte", address: "201 S College St, Charlotte, NC 28202", hours: "Mon–Sun: 8AM–10PM" },
    { name: "Walgreens — South Park", address: "4300 Park Rd, Charlotte, NC 28209", hours: "Mon–Sun: 7AM–11PM" },
    { name: "Walmart Supercenter — Matthews", address: "10310 E Independence Blvd, Matthews, NC 28105", hours: "Mon–Sun: 6AM–11PM" },
    { name: "FedEx Office — Charlotte", address: "550 S Tryon St, Charlotte, NC 28202", hours: "Mon–Fri: 7AM–9PM, Sat: 8AM–6PM" },
    { name: "CVS Pharmacy — Huntersville", address: "16429 Statesville Rd, Huntersville, NC 28078", hours: "Mon–Sun: 8AM–10PM" },
    { name: "Walgreens — Concord", address: "8525 Pit Stop Ct NW, Concord, NC 28027", hours: "Mon–Sun: 7AM–11PM" },
    { name: "CVS Pharmacy — Gastonia", address: "3690 E Franklin Blvd, Gastonia, NC 28056", hours: "Mon–Sun: 8AM–10PM" },
    { name: "Walmart — Fort Mill, SC", address: "1220 Highway 160 E, Fort Mill, SC 29708", hours: "Mon–Sun: 6AM–11PM" },
  ],
  dmvLocations: [
    {
      name: "NC DMV — Charlotte South",
      address: "8520 E Independence Blvd, Charlotte, NC 28227",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Driver's license and REAL ID services. Appointment recommended.",
      featured: true,
    },
    {
      name: "NC DMV — Charlotte North",
      address: "5311 Idlewild Rd N, Charlotte, NC 28227",
      hours: "Mon–Fri: 8AM–5PM",
      note: "REAL ID and passport-related ID services. Appointment strongly recommended.",
      featured: false,
    },
    {
      name: "NC DMV — Huntersville",
      address: "16225 Statesville Rd, Huntersville, NC 28078",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves Lake Norman area residents. REAL ID available.",
      featured: false,
    },
    {
      name: "NC DMV — Gastonia",
      address: "245 E Garrison Blvd, Gastonia, NC 28054",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves Gaston County and west Charlotte metro. REAL ID available.",
      featured: true,
    },
  ],
  airports: [
    {
      code: "CLT",
      name: "Charlotte Douglas International Airport",
      distance: "7 miles west of downtown Charlotte",
      address: "5501 Josh Birmingham Pkwy, Charlotte, NC 28208",
      note: "Major international hub serving the Charlotte metro and the Carolinas. American Airlines hub with direct flights to Europe, Mexico, the Caribbean, and major domestic destinations.",
      flightUrl: "https://www.cltairport.com/",
      flightLabel: "CLT Airport",
      featured: true,
    },
    {
      code: "GSO",
      name: "Piedmont Triad International Airport",
      distance: "85 miles northeast of Charlotte",
      address: "1000 Ted Johnson Pkwy, Greensboro, NC 27409",
      note: "Alternative airport for North Carolina residents. Additional domestic and limited international routes.",
      flightUrl: "https://www.flyfrompti.com/",
      flightLabel: "GSO Airport",
      featured: false,
    },
    {
      code: "RDU",
      name: "Raleigh-Durham International Airport",
      distance: "145 miles east of Charlotte",
      address: "2400 John Brantley Blvd, Morrisville, NC 27560",
      note: "Major alternative hub with additional international routes. Consider for long-haul international travel.",
      flightUrl: "https://www.rdu.com/",
      flightLabel: "RDU Airport",
      featured: false,
    },
  ],
};